import { yupResolver } from '@hookform/resolvers/yup';
import { I_IndicatorFormMeta } from '@Modules/admin/archiving/containers/formHandlers/validTransactionInquiry/transactionHistory/indicator/IndicatorFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: I_IndicatorFormMeta
} & TFormUIProps;

const IndicatorFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  const titles = ["Code Mode Entrée POS", "Autres"]
  // const inputModeCodePOSFields = getFormFieldsName(meta).slice(0, 12);
  // const othersFields = getFormFieldsName(meta).slice(12);
  const fieldsByCategory = [getFormFieldsName(meta).slice(0, 12), getFormFieldsName(meta).slice(12)]

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      {
        titles.map((title, i) =>
        (<CustomFieldSet key={i} title={title}>
          <CC.SimpleGrid columns={{ base: 1, lg: 3 }} gridRowGap={4} columnGap={16} my={4}>
            {
              fieldsByCategory[i].map((input, index) => (
                <CustomFormControl key={index} isLoading={isLoading} label={meta[input as keyof I_IndicatorFormMeta].label} isInvalid={!!errors[meta[input as keyof I_IndicatorFormMeta].name]}>
                  <CustomInput hasError={errors[meta[input as keyof I_IndicatorFormMeta].name]} register={register(meta[input as keyof I_IndicatorFormMeta].name)} meta={meta[input as keyof I_IndicatorFormMeta]}/>
                </CustomFormControl>
              ))
            }
          </CC.SimpleGrid>
        </CustomFieldSet>))
      }
      
      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default IndicatorFormUI;
